import useSocialProfiles from '@/hooks/swr/useSocialProfiles';

export const useIsFirstStatsLoaded = ({ SPID }) => {
    const { socialProfiles } = useSocialProfiles({
        revalidateOnMount: false,
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    const socialProfile = socialProfiles?.find((sp) => sp.id === SPID);

    if (socialProfile) {
        return socialProfile?.first_stats || socialProfile?.full_stats;
    }

    return false;
};
